import { type ReactNode } from 'react';
import { Archive, ChevronDown, KeyRound, RotateCcw } from 'lucide-react';

const ITEM =
  'inline-flex min-h-[36px] items-center gap-1.5 rounded-md px-sm py-1.5 text-xs text-text-secondary transition-colors hover:bg-surface-elevated hover:text-text-primary';
const ITEM_DANGER =
  'inline-flex min-h-[36px] items-center gap-1.5 rounded-md px-sm py-1.5 text-xs text-text-tertiary transition-colors hover:bg-surface-elevated hover:text-error';

type Props = {
  onReset: () => void;
  onStreakReset: () => void;
  onArchive: () => void;
};

function AdvancedRow(p: Props): ReactNode {
  return (
    <div className="flex flex-col gap-xs pt-sm">
      <button onClick={p.onReset} className={ITEM}>
        <KeyRound size={13} /> Resetear contrasena
      </button>
      <button onClick={p.onStreakReset} className={ITEM}>
        <RotateCcw size={13} /> Resetear streaks
      </button>
      <button onClick={p.onArchive} className={ITEM_DANGER}>
        <Archive size={13} /> Archivar
      </button>
    </div>
  );
}

export function AdvancedActions(p: Props): ReactNode {
  return (
    <details className="group">
      <summary className="flex cursor-pointer list-none items-center gap-xs text-[11px] uppercase tracking-wider text-text-tertiary/60 hover:text-text-secondary [&>svg]:open:rotate-180">
        <ChevronDown size={12} className="transition-transform" />
        Acciones avanzadas
      </summary>
      <AdvancedRow {...p} />
    </details>
  );
}
